<template>
    <div id="linkmanChange">
      <a-form :form="linkmanChangeForm" layout="vertical">
        <a-row>
          <a-col :span="8">
            <a-form-item class="required" :label="$t('linkman.changeModal.leaveDate')">
              <a-month-picker
                v-model="lastDate"
                v-decorator="['quitDate',{rules: [
                {required: true,message: $t('linkman.changeModal.leaveDateTip'),},
                {
                                        validator: lastDateValidator
                                        }
                ],}]"
                autocomplete="off"
                style="width: 100%;">
              </a-month-picker>
            </a-form-item>
          </a-col>
          <a-col :span="7" :offset="1">
            <a-form-item :label="$t('linkman.changeModal.enterDate')">
              <a-month-picker
                v-model="joinDate"
                v-decorator="['entryDate',{rules: [
                // {required: true,message: $t('linkman.changeModal.enterDateTip'),},
                ],}]"
                autocomplete="off"
                style="width: 100%;">
              </a-month-picker>
            </a-form-item>
          </a-col>
          <a-col :span="7" :offset="1">
            <a-form-item :label="$t('linkman.changeModal.newCompany')">
              <a-select :placeholder="$t('linkman.changeModal.inputTip')"
                        v-decorator="['businessId',{rules:[
                        {validator:newCompanyValidation}
                        ]}]"
                        showSearch
                        :showArrow="false"
                        :filterOption="false"
                        :defaultActiveFirstOption="false"
                        :notFoundContent="null"
                        @search="initAllCompanyList"
              >
                <a-select-option v-for="a in allCompanyList" :key="a.key" :value="a.id">{{a.companyName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
</template>

<script>
  import linkmanChangeRecordsApi from '@/api/database/linkmanChangeRecords'
  export default {
    name: 'linkmanChange',
    props:{
      linkmanId:null,
      modeType:{
        type:Number,
        default:1, //1新增客户联系人 2新增同行联系人  3 新增业主联系人
      },
    },
    data(){
      return{
        joinDate:undefined,
        lastDate:undefined,
        linkmanChangeForm:this.$form.createForm(this),
        allCompanyList:[],//公司列表
      }
    },
    watch:{
      'joinDate'(val){
        this.$nextTick(()=>{
          this.linkmanChangeForm.validateFields([`quitDate`],{force:true}, (errors, values) => {
          });
        })
      }
    },
    beforeCreate () {
      this.linkmanChangeForm = this.$form.createForm(this)
    },
    mounted(){
      this.init()
    },
    methods:{
      newCompanyValidation(rule,value,cb){
        if(this.joinDate && !value){
          cb(this.$t('news.editPage.errorInfo.downIdIsNull'))
        }else{
          cb()
        }
      },
      lastDateValidator(rule,value,cb){
        if(this.joinDate){
          this.joinDate.startOf('month')
          this.lastDate.startOf('month')
          if(this.joinDate.diff(this.lastDate,'days') < 0){
            cb(this.$t('news.editPage.errorInfo.joinDateLELastDate'))
          }else{
            cb()
          }
        }else{
          cb()
        }
      },
      initAllCompanyList(companyName){
        let p = new Promise((resolve, reject)=>{
          linkmanChangeRecordsApi.queryByName(companyName,this.modeType).then(res=>{
            if(res.code == 1){
              this.allCompanyList = res.data != null ? res.data : []
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      init(){

      },
      submit(){
        this.linkmanChangeForm.validateFieldsAndScroll({force:true},(err, values) => {
          if (!err) {
            this.fillData(values);
          }else{
            this.$emit("error");
          }
        });
      },
      fillData(data){
        // data["type"] =  this.modeType;
        if(this.allCompanyList.length > 0){
          data["type"] = this.allCompanyList.find(e=>{return e.id == data.businessId}).type
        }
        var quitLinkmanVO = {
          id:this.linkmanId
        }
        data["quitLinkmanVO"] = quitLinkmanVO;
        this.saveChange(data);
      },
      saveChange(data){
        linkmanChangeRecordsApi.insert(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('linkman.changeModal.saveSuccessTip'));
            this.$emit("saveChangeSuccess");
          }else{
            this.$emit("error");
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #linkmanChange{
    background: rgba(248,249,251,0.62);
    border-radius: 0 0 4px 4px;
    padding: 40px 20px;
  }
</style>